var account = "Account";
var accountSettings = "Impostazioni account";
var charging = "Ricarica";
var contactInfo = "Recapiti";
var dashboard = "Dashboard";
var home = "Casa";
var myProducts = "I miei prodotti";
var orderHistory = "Cronologia ordini";
var paymentMethod = "Modalità di pagamento";
var profileSettings = "Impostazioni del profilo";
var referAndEarn = "Segnala e guadagna";
var signOut = "Esci";
var it_IT = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, it_IT as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
